import { css } from 'styled-components'

import theme from '../constants/theme'

const defaultBreakpoints = {
  huge: theme.breakpoints[3],
  large: theme.breakpoints[2],
  medium: theme.breakpoints[1],
  small: theme.breakpoints[0]
}

function getSizeFromBreakpoint (breakpointValue, breakpoints = {}) {
  if (breakpoints[breakpointValue]) {
    return breakpoints[breakpointValue]
  } else if (parseInt(breakpointValue, 10)) {
    return breakpointValue
  } else {
    console.error('styled-media-query: No valid breakpoint or size specified for media.')
    return '0'
  }
}

export function media (breakpoints = defaultBreakpoints) {
  const lessThan = (breakpoint) => (...args) => css`
    @media (max-width: ${getSizeFromBreakpoint(breakpoint, breakpoints)}) {
      ${css(...args)}
    }
  `

  const greaterThan = (breakpoint) => (...args) => css`
    @media (min-width: ${getSizeFromBreakpoint(breakpoint, breakpoints)}) {
      ${css(...args)}
    }
  `

  const between = (firstBreakpoint, secondBreakpoint) => (...args) => css`
    @media (min-width: ${getSizeFromBreakpoint(firstBreakpoint, breakpoints)}) and
      (max-width: ${getSizeFromBreakpoint(secondBreakpoint, breakpoints)}) {
      ${css(...args)}
    }
  `

  return Object.assign({
    lessThan,
    greaterThan,
    between
  })
}

export default media()


// WEBPACK FOOTER //
// ./src/utils/style-utils.js